var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F3F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3324 10.8892L11.7769 14.4447C11.286 14.9356 11.286 15.7316 11.7769 16.2225C12.2678 16.7134 13.0637 16.7134 13.5547 16.2225L17.1102 12.6669C18.0921 11.6851 18.0921 10.0932 17.1102 9.11138C16.1284 8.12954 14.5365 8.12954 13.5547 9.11138L9.9991 12.6669C8.52634 14.1397 8.52634 16.5275 9.9991 18.0003C11.4719 19.473 13.8597 19.473 15.3324 18.0003L18.888 14.4447",
    stroke: "#5A5F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.6d71fc84bfadbafda335177253bd4d84.svg";
export { ForwardRef as ReactComponent };